import emitter from "@webcore/core/events/eventemitter.ts";
import * as Sentry from "@sentry/react";
import { initializeCreatorData } from "@/data/data";


if (import.meta.env.DEV ) {
  // import("./utils/stats").then(({ initStats }) => initStats()).catch(() => {});
  import("./utils/eruda").then(({ initEruda }) => initEruda()).catch(() => {});
}

void initializeCreatorData().finally(() => {
  import("./main.app.ui").then(({ initUI }) => {
    initUI();
  });
});

emitter.on("ui-ready", () => {
  import("./main.app").then(({ initApp }) => {
    void initApp();
  });
});

//----------------------------------------------------------------

emitter.on("initialized", () => {
  emitter.emit("load");
});

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://b348987e49f182f8e94e7932d7dc3a68@o1388406.ingest.us.sentry.io/4511448830181376",
    // The AR experience logs/fetches enough that default breadcrumbs balloon the
    // envelope past Sentry's ~5MB cap and the server 413s every event. Trim hard:
    // skip console/dom breadcrumbs (we re-send the important console.errors via
    // reportToSentry anyway) and drop any individual breadcrumb that's still huge.
    maxBreadcrumbs: 20,
    integrations: [
      Sentry.breadcrumbsIntegration({
        console: false,
        dom: false,
      }),
    ],
    beforeBreadcrumb(breadcrumb) {
      try {
        if (JSON.stringify(breadcrumb).length > 5000) return null;
      } catch {
        return null;
      }
      return breadcrumb;
    },
  });
}